enum TimelineViews {
  CUSTOMER_VIEW = 'CUSTOMER_VIEW',
  TASKS_VIEW = 'TASKS_VIEW',
}

export default TimelineViews;
